import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import {ENGLISH_LANGUAGE} from "./languageConstants/englishLanguage"
import { SPANISH_LANGUAGE } from "./languageConstants/spanishLanguage";

const resources = {
  en: {
    translation: ENGLISH_LANGUAGE
  },
  es: {
    translation: SPANISH_LANGUAGE,
  },
};

i18n.use(initReactI18next).init({
  resources,
  fallbackLng: "en",
  debug: true,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
